import React, { useState, useEffect, useCallback } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import "./wireProduction.css"
import logoWireProduction from "../../imagens/logos/logoWireProduction.png"



function WireProductionCapabilities({ wireProductionList }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)


    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0
            ? setSlideNumber(wireProductionList.length - 1)
            : setSlideNumber(slideNumber - 1)
    }, [slideNumber, wireProductionList.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === wireProductionList.length
            ? setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, wireProductionList.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);


    return (
        <div >
            {
                openModal &&
                <div className="wireProductionSliderWrap">
                    <FontAwesomeIcon icon={faCircleXmark} className="wireProductionBtnClose" onClick={() => handleCloseModal()} />
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="wireProductionBtnPrev" onClick={() => prevSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="wireProductionBtnNext" onClick={() => nextSlide()} />
                    <img className="wireProductionfullScreenImage img-fluid" src={wireProductionList[slideNumber].img} alt="" />
                </div>
            }
            <div className='img-custom-size img-fluid ms-2'>
                <img src={logoWireProduction} alt='logoWireProduction'></img>
            </div>
            <div className="wireProductionGalleryWrap mx-2">
                {
                    wireProductionList && wireProductionList.map((image, index) => {
                        return (
                            <div
                                className="wireProductionSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="wireProduction" />

                            </div>
                        )
                    })
                }
            </div>
            <div className="text-center text-nowrap my-3">
                <Link to="/Capabilities/Production">
                    <button className="buttonCapabilities">Voltar para compêtencias produtivas</button>
                </Link>
            </div>
        </div >
    )
}

export default WireProductionCapabilities